package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * Phase 3：`intercept` 块 AST。
 *
 * 声明在 screen 块顶层，定义该页面的拦截条件：
 * - [menuType]：匹配的 menuType（如 "options"、"minecraft:generic_9x54"）
 * - [condition]：可选的条件表达式（为空 = 无条件匹配）
 */
data class InterceptAst(
    val menuType: String,
    val condition: ExprAst? = null,
    override val position: SourcePosition,
) : AstNode
